import dayjs from "dayjs";

export const calculateAge = (birthDate: string | Date): number => {
  const today = dayjs();
  const birthDay = dayjs(birthDate);

  let age = today.year() - birthDay.year();

  if (today.isBefore(birthDay.add(age, "year"))) {
    age -= 1;
  }

  return age;
};
